/* eslint-disable
    consistent-return,
    default-case,
    prefer-rest-params
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import LabeledSegmentsRingView from 'molbio/maps/circular/LabeledSegmentsRingView';
import arcs from 'molbio/maps/circular/Arcs';
import * as selectioncontextmenu from 'components/SelectionContextMenu';
import {DASHED_LINE, SOLID_LINE} from 'util/SVGUtil';

class CircularPrimersView extends LabeledSegmentsRingView {
  static initClass() {
    this.prototype.className = 'primers';
    this.prototype.singularClassName = 'primer';
    this.prototype.tagName = 'g';
  }

  initialize() {
    this.fill = this.fill.bind(this);
    super.initialize(...arguments);
  }

  contextMenuData() {
    return selectioncontextmenu.PRIMER_MENU;
  }
  contextMenuOptions(d) {
    return {primer: d};
  }

  arc(d) {
    switch (d.strand()) {
      case 1:
        return arcs.forwardArrowArc();
      case 0:
        return arcs.arc();
      case -1:
        return arcs.backwardArrowArc();
    }
  }

  fill(d) {
    return `url(#stripe-${this.cid}-${d.uid()})`;
  }

  data() {
    const sequence = this.model.get('sequence');
    return sequence.sequencePrimers().slice(0, sequence.length());
  }

  registerListeners() {
    super.registerListeners();
    const primers = this.model.get('sequence').sequencePrimers();
    this.listenTo(primers, 'layerChange', function () {
      this.invalidateData();
      return this.triggerRedraw();
    });
    return this.listenTo(primers, 'change:hover change:selected', this.handleHover);
  }

  clickAction(e, d) {
    return d.click(this.model.get('sequence'), e.shiftKey);
  }

  dblClickAction(e, d) {
    return d.dblClick(this.model.get('sequence'), e.shiftKey);
  }

  setConstraints(outerRadius) {
    return this.setOuterRadius(outerRadius);
  }

  redrawPlasmid() {
    return true;
  }

  storeBounds(rings) {
    if (rings == null) {
      ({rings} = this);
    }
    this.rings = rings;
    const innerRadius = this.getOuterRadius() - this.layout.get('ringHeight') * this.rings;
    this.layout.set('innerRadius', innerRadius);
    return this.updateRadius();
  }

  zeroBounds() {
    this.layout.set('innerRadius', this.layout.get('outerRadius'));
    return this.updateRadius();
  }

  layerBounds(layer) {
    return {
      innerRadius: this.radiusIn(layer + 1),
      outerRadius: this.radiusIn(layer) - this.layout.vMargin(),
    };
  }

  baseLine(layer) {
    return this.radiusIn(layer + 2 / 3 + 1 / 6);
  } // FIXME: What is this magic

  eachRing(root) {
    super.eachRing(root);
    root.attr('data-test-component', 'circularPrimersView');
    root.attr('data-test-element', 'primerRoot');
    root.attr('stroke-dasharray', (d) => (d.get('_primer').isNew() ? DASHED_LINE : SOLID_LINE));
    const pattern = root.select('defs').select('pattern');
    pattern.attr('id', (d) => `stripe-${this.cid}-${d.uid()}`);
    const patternRect = root.select('defs').select('pattern').select('rect');
    return patternRect.attr('fill', (d) => d.color());
  }

  enterRing(enter) {
    super.enterRing(enter);
    const pattern = enter
      .append('svg:defs')
      .append('svg:pattern')
      .attr('patternUnits', 'userSpaceOnUse')
      .attr('width', 14)
      .attr('height', 14);
    pattern
      .append('svg:rect')
      .attr('width', 14)
      .attr('height', 14)
      .attr('fill', (d) => d.color());
    pattern
      .append('svg:path')
      .attr('fill', 'black')
      .attr('fill-opacity', '0.15')
      .attr('d', 'M5.232,17.089l-3.536-3.535L16.268-1.018l3.536,3.536L5.232,17.089z');
    pattern
      .append('svg:path')
      .attr('fill', 'black')
      .attr('fill-opacity', '0.15')
      .attr('d', 'M-1.839,10.018l-3.535-3.536L9.197-8.089l3.536,3.535L-1.839,10.018z');

    return enter;
  }

  cutoffRadius() {
    return this.model.get('primerCutoffRadius');
  }

  // Overrides SegmentsRingView.stroke
  stroke(d) {
    return d.outlineColor(this.model.get('sequence'));
  }
}
CircularPrimersView.initClass();

export default CircularPrimersView;
